import { Text } from '@wix/design-system';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { RuleListStatus } from '../../../types';
import { dataHooks } from '../../../utils/datahooks';
import { useCollapseItems } from '../../../utils/use-on-rule-group-toggle';
import { useUnsavedChangesHandlers } from '../../../utils/use-unsaved-changes-handlers';
export const useToggleFixer = ruleResult => {
  var _footerLabels$buttonT;
  const {
    onApply,
    onCancel,
    onEdit,
    footerLabels,
    toggleLabel,
    onSelect
  } = ruleResult.fixerProps;
  const {
    description,
    tips
  } = ruleResult;
  const unsavedChangesHandlers = useUnsavedChangesHandlers();
  const {
    collapseRule
  } = useCollapseItems();
  const initialValue = ruleResult.status === RuleListStatus.passed;
  const [toggleChecked, setToggleChecked] = useState(initialValue);
  const [showLoader, setShowLoader] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const onApplyClick = useCallback(async checked => {
    try {
      setShowLoader(true);
      await onApply(checked);
      unsavedChangesHandlers == null || unsavedChangesHandlers.setUnsavedChanges(false, () => Promise.resolve());
    } catch (e) {
      console.error(e);
    }
    setShowLoader(false);
    collapseRule();
  }, [collapseRule, onApply, unsavedChangesHandlers]);
  const onChange = useCallback(() => {
    setToggleChecked(!toggleChecked);
    onSelect == null || onSelect(!toggleChecked);
  }, [onSelect, toggleChecked]);
  const onEditClick = useCallback(() => {
    setIsEditMode(true);
    onEdit == null || onEdit();
  }, [setIsEditMode, onEdit]);
  const onCancelClick = useCallback(() => {
    collapseRule();
    setIsEditMode(false);
    onCancel == null || onCancel();
    unsavedChangesHandlers == null || unsavedChangesHandlers.setUnsavedChanges(false, () => Promise.resolve());
  }, [collapseRule, onCancel, unsavedChangesHandlers]);
  useEffect(() => {
    return () => {
      setIsEditMode(false);
      setShowLoader(false);
    };
  }, []);
  const formattedToggleLabel = useMemo(() => {
    return typeof toggleLabel === 'string' ? /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      secondary: true
    }, toggleLabel) : toggleLabel;
  }, [toggleLabel]);
  return {
    checkedValue: toggleChecked,
    description,
    isEditMode,
    onChange,
    onEditClick,
    ruleFooterProps: {
      dataHook: dataHooks.footerToggleFixer(ruleResult.dataHook),
      dismissButtonProps: {
        label: footerLabels.dismiss,
        onClick: onCancelClick,
        type: ((_footerLabels$buttonT = footerLabels.buttonTypes) == null ? void 0 : _footerLabels$buttonT.dismiss) ?? 'textButton'
      },
      submitButtonProps: {
        disabled: toggleChecked === initialValue,
        label: footerLabels.submit,
        onClick: () => onApplyClick(toggleChecked),
        showLoader
      }
    },
    tips,
    toggleLabel: formattedToggleLabel
  };
};
//# sourceMappingURL=use-toggle-fixer.js.map